import type { StoreApi } from 'zustand';

type StoreLike<TState> = Pick<StoreApi<TState>, 'getState' | 'setState'>;

export abstract class BaseStore<TState = unknown> {
  abstract store: StoreLike<TState>;

  get get(): StoreLike<TState>['getState'] {
    return this.store.getState;
  }

  get set(): StoreLike<TState>['setState'] {
    return this.store.setState;
  }
}
